import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  return (
    <section 
      data-testid="final-cta-section"
      className="py-20 lg:py-28 bg-[#0F172A]"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 
          data-testid="final-cta-title"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Ready to Transform Your CAD Workflows?
        </h2>
        
        <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
          Don't let manual processes slow you down. Partner with us for custom CAD/CAM software development solutions that boost productivity and reduce errors.
        </p>
        
        <Link to="/contact">
          <Button 
            data-testid="final-cta-button"
            className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-10 py-6 text-lg font-medium rounded-xl group"
          >
            Contact Us
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default FinalCTA;
